var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import usePriceListProductByUuid from "@/react/Webshop/hooks/usePriceListProductByUuid";
import { useShoppingCart } from "@/react/Webshop/providers/ShoppingCartProvider";
import { callAPI } from "@/react/lib/common";
import { useMemo, useState } from "react";
import { PRODUCT_RETOUCH_FILE_UUID } from "@/react/Webshop/providers/PriceListProvider";
const useRetouchPictures = (pictures) => {
    const product = usePriceListProductByUuid(PRODUCT_RETOUCH_FILE_UUID);
    const [isUpdatingCart, setIsUpdatingCart] = useState(false);
    const { items, updateCart: reloadShoppingCart } = useShoppingCart();
    const [picturesSubProducts, setPicturesSubProducts] = useState(getRetouchProducts(pictures.map((p) => p.uuid), items));
    const totalPrice = useMemo(() => {
        var _a;
        if (!product) {
            return 0;
        }
        // FIXME: Simple price calculator:
        let totalPrice = 0;
        for (const pictureUuid in picturesSubProducts) {
            const subProductUuids = picturesSubProducts[pictureUuid];
            if (subProductUuids.length > 0) {
                totalPrice += product === null || product === void 0 ? void 0 : product.productprices[0].price;
                for (const subProductUuid of subProductUuids) {
                    const subProduct = (_a = product.subproducts) === null || _a === void 0 ? void 0 : _a.find((s) => s.uuid === subProductUuid);
                    if (subProduct) {
                        totalPrice += subProduct.extraprice;
                    }
                }
            }
        }
        return totalPrice;
    }, [product, picturesSubProducts]);
    const numPicturesWithRetouch = useMemo(() => {
        return Object.values(picturesSubProducts).filter((arr) => arr.length > 0)
            .length;
    }, [picturesSubProducts]);
    const handleToggleSubProduct = (pictureUuid) => (subProduct) => {
        setPicturesSubProducts((picturesSubProducts) => {
            var _a;
            const current = (_a = picturesSubProducts[pictureUuid]) !== null && _a !== void 0 ? _a : [];
            let updated;
            if (current.includes(subProduct)) {
                updated = current.filter((sp) => sp !== subProduct);
            }
            else {
                updated = [...current, subProduct];
            }
            return Object.assign(Object.assign({}, picturesSubProducts), { [pictureUuid]: updated });
        });
    };
    const updateCart = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsUpdatingCart(true);
        yield callAPI("/api/webshop/cart/retouch", "PUT", {
            items: picturesSubProducts,
        });
        yield reloadShoppingCart();
    });
    return {
        handleToggleSubProduct,
        product,
        picturesSubProducts,
        isUpdatingCart,
        updateCart,
        numPicturesWithRetouch,
        totalPrice,
    };
};
const getRetouchProducts = (pictureUuids, items) => {
    var _a, _b, _c;
    const retouchPictures = {};
    for (const pictureUuid of pictureUuids) {
        for (const item of items) {
            if (item.product.uuid !== PRODUCT_RETOUCH_FILE_UUID) {
                continue;
            }
            if (((_b = (_a = item.fileRetouch) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.uuid) === pictureUuid) {
                retouchPictures[pictureUuid] = (_c = item.subProductUuids) !== null && _c !== void 0 ? _c : [];
                break;
            }
        }
        if (typeof retouchPictures[pictureUuid] === "undefined") {
            retouchPictures[pictureUuid] = [];
        }
    }
    return retouchPictures;
};
export default useRetouchPictures;
